import { ClientAPI } from '@/redux/api';
import { UserLicense, UserLicenseResponse } from '@/@types/client-api';

const tags = [
  'Licenses',
  'CreditTrackerData',
  { type: 'CreditTrackerData', id: 'Certificates' }
] as const;
const userLicensesEndpoints = ClientAPI.injectEndpoints({
  endpoints: builder => ({
    getLicenses: builder.query<UserLicenseResponse, void>({
      query: () => ({
        url: '/user/licenses',
        method: 'GET'
      }),
      providesTags: result => [
        'Licenses' as const,
        ...(result?.items ?? []).map(item => ({
          type: 'Licenses' as const,
          id: item.creditRegion_SK
        }))
      ]
    }),
    postLicense: builder.mutation<void, UserLicense>({
      query: body => ({
        url: '/user/licenses',
        method: 'POST',
        body
      }),
      invalidatesTags: (_result, error, bodySent) =>
        error ? [] : [...tags, 'CreditPlans', { type: 'Licenses', id: bodySent.creditRegion_SK }]
    }),
    updateLicense: builder.mutation<void, UserLicense>({
      query: body => ({
        url: '/user/licenses',
        method: 'PUT',
        body
      }),
      invalidatesTags: tags
    }),
    deleteLicense: builder.mutation<void, Pick<UserLicense, 'sk'>>({
      query: ({ sk }) => ({
        url: `/user/licenses/${sk}`,
        method: 'DELETE'
      }),
      invalidatesTags: tags
    }),
    updateCertificatePreference: builder.mutation<void, number>({
      query: body => ({
        url: '/user/licenses/certificate-preference',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body
      }),
      invalidatesTags: ['Licenses']
    })
  })
});

export const {
  useGetLicensesQuery,
  useLazyGetLicensesQuery,
  usePostLicenseMutation,
  useUpdateLicenseMutation,
  useDeleteLicenseMutation,
  useUpdateCertificatePreferenceMutation
} = userLicensesEndpoints;

export default userLicensesEndpoints;
